import { SKILL_SLOT_MAX } from "@/character/skills/constants";

export function formatSkillSlotCooldownLabel(remainingMs: number): string {
  if (remainingMs <= 0) return "";
  if (remainingMs < 10_000) {
    const sec = remainingMs / 1000;
    return sec < 1 ? sec.toFixed(1) : String(Math.ceil(sec));
  }
  return String(Math.ceil(remainingMs / 1000));
}

/** 1 = full overlay (just used), 0 = ready. */
export function skillSlotCooldownProgress(remainingMs: number, durationMs: number): number {
  if (remainingMs <= 0 || durationMs <= 0) return 0;
  return Math.min(1, remainingMs / durationMs);
}

export function bumpSlotCooldown(
  untilBySlot: number[],
  durationBySlot: number[],
  slot: number,
  until: number,
  durationMs: number,
): void {
  if (slot < 0 || slot >= SKILL_SLOT_MAX) return;
  const prev = untilBySlot[slot] ?? 0;
  if (until > prev) {
    untilBySlot[slot] = until;
    durationBySlot[slot] = Math.max(1, durationMs);
  }
}

export function bumpSlotCooldownRecord(
  untilBySlot: Record<number, number>,
  durationBySlot: Record<number, number>,
  slot: number,
  until: number,
  durationMs: number,
): void {
  if (slot < 0 || slot >= SKILL_SLOT_MAX) return;
  const prev = untilBySlot[slot] ?? 0;
  if (until > prev) {
    untilBySlot[slot] = until;
    durationBySlot[slot] = Math.max(1, durationMs);
  }
}

export function clearSlotCooldown(
  untilBySlot: number[],
  durationBySlot: number[],
  slot: number,
): void {
  untilBySlot[slot] = 0;
  durationBySlot[slot] = 0;
}

export function clearSlotCooldownRecord(
  untilBySlot: Record<number, number>,
  durationBySlot: Record<number, number>,
  slot: number,
): void {
  untilBySlot[slot] = 0;
  durationBySlot[slot] = 0;
}

export function skillSlotCooldownOverlayHtml(label: string): string {
  return `<span class="home-skill-slot-cd" aria-hidden="true">
    <span class="home-skill-slot-cd-fill" style="--cd-remain: 1"></span>
    <span class="home-skill-slot-cd-label">${label}</span>
  </span>`;
}

export function updateSkillBarCooldownDom(
  bar: HTMLElement,
  remainingMs: (slotIndex: number) => number,
  durationMs: (slotIndex: number) => number,
  _opts?: { respectDisabled?: boolean },
): void {
  bar.querySelectorAll<HTMLButtonElement>("[data-skill-slot]").forEach((btn) => {
    const slotIndex = Number(btn.dataset.skillSlot);
    if (!Number.isFinite(slotIndex)) return;
    const remain = remainingMs(slotIndex);
    const dur = durationMs(slotIndex);
    const cdEl = btn.querySelector<HTMLElement>(".home-skill-slot-cd");
    if (!cdEl) return;

    if (remain <= 0) {
      cdEl.hidden = true;
      btn.classList.remove("home-skill-slot--cooldown");
      if (!btn.classList.contains("tower-skill-slot--off")) {
        btn.disabled = false;
      }
      return;
    }

    cdEl.hidden = false;
    btn.classList.add("home-skill-slot--cooldown");
    if (!btn.classList.contains("tower-skill-slot--off")) {
      btn.disabled = true;
    }
    const progress = skillSlotCooldownProgress(remain, dur);
    const fill = cdEl.querySelector<HTMLElement>(".home-skill-slot-cd-fill");
    const label = cdEl.querySelector<HTMLElement>(".home-skill-slot-cd-label");
    fill?.style.setProperty("--cd-remain", progress.toFixed(3));
    if (label) label.textContent = formatSkillSlotCooldownLabel(remain);
  });
}
